import { render, staticRenderFns } from "./RolView.vue?vue&type=template&id=574b22fc"
import script from "./RolView.vue?vue&type=script&lang=js"
export * from "./RolView.vue?vue&type=script&lang=js"
import style0 from "./RolView.vue?vue&type=style&index=0&id=574b22fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports